import { config } from '@config/env';

const PLUGIN_PATH = '/plugin/corgee-plugin.umd.cjs';
const SCRIPT_ID = 'corgee-plugin-script';

/**
 * Ensures the URL has a protocol; without it the browser resolves it
 * relative to the current route (e.g. /V2/ProjectDetails/host/plugin/...).
 */
const toAbsolute = (url: string): string =>
{
  if (!url || url.startsWith('/')) return url;
  if (/^https?:\/\//i.test(url)) return url;
  return `https://${url}`;
};

/**
 * Resolves the plugin URL from the current environment.
 * VITE_JS_pluginURL overrides it (dev/qa point to the QA bundle).
 */
export const getCorgeePluginUrl = (): string =>
{
  const override = ((import.meta.env['VITE_JS_pluginURL'] as string) || '').trim();
  if (override) return toAbsolute(override);

  const baseUrl = (config.web.url || '').trim().toLowerCase().replace('/chat/', '/');
  if (!baseUrl) return PLUGIN_PATH;

  try
  {
    return new URL(PLUGIN_PATH, toAbsolute(baseUrl)).href;
  }
  catch
  {
    return toAbsolute(baseUrl).replace(/\/+$/, '') + PLUGIN_PATH;
  }
};

/** Injects the CorgeePlugin UMD bundle once, exposing window.CorgeePlugin. */
export const loadCorgeePlugin = (): void =>
{
  if (document.getElementById(SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.src = getCorgeePluginUrl();
  script.async = true;
  script.onerror = () => console.error('Failed to load CorgeePlugin from', script.src);

  document.body.appendChild(script);
};
